var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('no-ssr',[_c('transition',{attrs:{"name":_vm.transitionName}},[(_vm.isShow)?_c('div',{staticClass:"FeedbackBuoy",on:{"click":_vm.navTo}},[_c('i',{staticClass:"icon_feedback"}),_vm._v(" "),_c('div',{staticClass:"txt-feedback"},[_vm._v("\n          意见 "),_c('br'),_vm._v("\n          反馈\n        ")])]):_vm._e()])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }